import { gql } from 'react-apollo';

export const getMembersStatistics = gql`
  query getChurchDailyMembersStatistics($churchId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        church(church_id: $churchId) {
          daily(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            members {
              total
              joined: joined_for_period
            }
          }
        }
      }
    }
  }
`;

export const getPointsEarnedStatistics = gql`
  query getChurchDailyPointsEarnedStatistics($churchId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        church(church_id: $churchId) {
          daily(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            totalPointsEarned: total_points_earned {
              totalPointsEarned: total_points_earned
              delta
            }
          }
        }
      }
    }
  }
`;

export const getOvercomingStatistics = gql`
  query getChurchDailyOvercomingStatistics($churchId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        church(church_id: $churchId) {
          daily(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            overcomingRecordsSubmitted: overcoming_records_submitted
          }
        }
      }
    }
  }
`;

export const getFastingStatistics = gql`
  query getChurchDailyFastingStatistics($churchId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        church(church_id: $churchId) {
          daily(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            fasting {
              full
              forMeal: for_meal
              membersCount: members_count
            }
          }
        }
      }
    }
  }
`;

export const getGuestCardsActivitiesStatistics = gql`
  query getChurchDailyGuestCardsActivitiesStatistics($churchId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        church(church_id: $churchId) {
          daily(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            guestCardActivities: guest_card_activities {
              guestsTotal: guests_total,
              guestsForPeriod: guests_for_period,
              iaksSubmitted: iaks_submitted,
              iaksSubmittedDelta: iaks_submitted_delta,
              iaksByTypeDistribution: iaks_by_type_distribution {
                iak {
                  name
                }
                count
              }
            }
          }
        }
      }
    }
  }
`;

export const getPrayingStatistics = gql`
  query getChurchDailyPrayingStatistics($churchId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        church(church_id: $churchId) {
          daily(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            praying {
              timePrayed: time_prayed
              timePrayedDelta: time_prayed_delta
              timeDistribution: time_distribution {
                intervalStart: interval_start
                timePrayed: time_prayed
              }
            }
          }
        }
      }
    }
  }
`;

export const getGroupComparisonStatistics = gql`
  query getChurchDailyGroupComparisonStatistics($churchId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        church(church_id: $churchId) {
          daily(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            groupComparison: group_comparison {
              group {
                name
              }
              pointsAvg: points_avg
            }
          }
        }
      }
    }
  }
`;

export const getGoalsAndAveragesStatistics = gql`
  query getChurchDailyGoalsAndAveragesStatistics($churchId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        church(church_id: $churchId) {
          daily(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            goalsAndAverages: goals_and_averages {
              pointsAverage: points_average
              timePrayedAverage: time_prayed_average
              iaksAverage: iaks_average
              pointsGoalPercentage: points_goal_percentage
              timePrayedGoalPercentage: time_prayed_goal_percentage
              iaksGoalPercentage: iaks_goal_percentage
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/statistics/church/daily/queries/queries.js